

  document.addEventListener('DOMContentLoaded', function() {

      // Check if blog category scroll to main blog section
      if (window.location.href.includes('/blogs/')) {
        if (window.location.href.includes('/tagged/')) {
          const blogSection = document.querySelector('.shopify-section--main-blog');
    
          if (blogSection) {
            blogSection.scrollIntoView();
            // const topPosition = blogSection.getBoundingClientRect().top + window.pageYOffset - 70;
            // window.scrollTo(0, topPosition);
          }
        }
      }
    
    // custom no index tag for search within collections i.e. /collections/shop?q=hoop&view=products
    if (window.location.href.includes('/collections/') && window.location.search.includes('q=')) {
      var meta = document.createElement('meta');
      meta.name = 'robots';
      meta.content = 'noindex, follow';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
    
    // Product page is this a gift?
    const giftCheckbox = document.querySelector('.gift-product-options input[type="checkbox"]');
    const giftFields = document.querySelector('.gift-product-options__fields');

    if (giftCheckbox && giftFields) {
      giftCheckbox.addEventListener('change', function () {
        if (giftCheckbox.checked) {
          giftFields.classList.remove('js:hidden');
        } else {
          giftFields.classList.add('js:hidden');
        }
      });
    }
        
    const modal = document.getElementById('special-order-confirmation');
    const addToCartButton = modal?.querySelector('button[type="submit"]');
  
    // When the button is clicked, hide the modal
    addToCartButton?.addEventListener('click', function() {
      modal.style.display = 'none'; // Hide the modal
      modal.style.opacity = '0'; // Optional: for a fade-out effect
    });
  
    // hides mega menu on close 
    document.querySelectorAll('.header__primary-nav-item .close-button').forEach(button => {
    button.addEventListener('click', function() {
      
      const parentMenuDisclosure = this.closest('.header__menu-disclosure');
      
      if (parentMenuDisclosure) {
        
        const megaMenu = parentMenuDisclosure.querySelector('.mega-menu');

        if (megaMenu) {
          
          let fadeEffect = setInterval(function() {
            if (!megaMenu.style.opacity) {
              megaMenu.style.opacity = 1;
            }
            if (megaMenu.style.opacity > 0) {
              megaMenu.style.opacity -= 0.1;
            } else {
              clearInterval(fadeEffect);

              parentMenuDisclosure.setAttribute('aria-expanded', 'false');
              parentMenuDisclosure.removeAttribute('open');
            }
          }, 20); 
        }
      }
    });
  });

  // hides/shows cart number
  const cartDot = document.querySelector('.header-cart .header__cart-dot');
  const headerCart = document.querySelector('.header-cart');

  if (cartDot && headerCart) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          if (cartDot.classList.contains('is-visible')) {
            headerCart.classList.add('has-items');
          } else {
            headerCart.classList.remove('has-items');
          }
        }
      });
    });

    // Configure the observer to watch for attribute changes
    const config = { attributes: true };

    // Start observing the target element
    observer.observe(cartDot, config);
  }
    
});